// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ow-0";